import type { TFunction } from 'i18next';

/* eslint-disable i18next/no-literal-string -- wire enum values; the labels come from t() */
export const REQUIREMENTS = ['required', 'recommended', 'accepted'] as const;
export const SCOPES = ['placement', 'general_upload', 'api'] as const;
/* eslint-enable i18next/no-literal-string */

export function requirementLabel(t: TFunction<'admin'>, value: string): string {
  switch (value) {
    case 'required':
      return t('admin.adFormats.requirement.required');
    case 'recommended':
      return t('admin.adFormats.requirement.recommended');
    case 'accepted':
      return t('admin.adFormats.requirement.accepted');
    default:
      return value;
  }
}

export function scopeLabel(t: TFunction<'admin'>, value: string): string {
  switch (value) {
    case 'placement':
      return t('admin.adFormats.scope.placement');
    case 'general_upload':
      return t('admin.adFormats.scope.general_upload');
    case 'api':
      return t('admin.adFormats.scope.api');
    default:
      return value;
  }
}

export function transparencyLabel(t: TFunction<'admin'>, value: string): string {
  switch (value) {
    case 'supported':
      return t('admin.adFormats.spec.transparency.supported');
    case 'not_supported':
      return t('admin.adFormats.spec.transparency.not_supported');
    case 'flattened':
      return t('admin.adFormats.spec.transparency.flattened');
    case 'required':
      return t('admin.adFormats.spec.transparency.required');
    default:
      return value;
  }
}

export interface ProvenanceDraft {
  requirement: string;
  scope: string;
  notes: string;
}

export function emptyProvenance(): ProvenanceDraft {
  return {
    // eslint-disable-next-line i18next/no-literal-string -- wire enum default
    requirement: 'required',
    // eslint-disable-next-line i18next/no-literal-string -- wire enum default
    scope: 'placement',
    notes: '',
  };
}
